<template>
  <div class="container">
    <My-Breadcrumb :breadcrumbs="breadcrumbs" />
    <div class="mainBox">
      <div class="control_box">
        <Search-bar :inputs="inputs" :selects="selects" :timeRange="timeRange" @search="search" @reset="search" />
        <div class="control_box_bottom">
          <a-button type="primary" icon="printer" @click="downloadExcel" :disabled="tableData.length == 0"
            style="margin-right:10px;">导出</a-button>
          <a-button type="primary" @click="changeTable" style="margin-right:10px;">
            查看销量统计
          </a-button>
        </div>
      </div>
      <!-- 内容区域 -->
      <div class="show_box">
        <a-table v-show="isOrderTable" :columns="columns" :data-source="tableData" :loading="loading"
          :rowKey="tableData => tableData.id" :pagination="pagination" @change="handleTableChange" :scroll="{x:true}">
          <span slot="dis" slot-scope="record">
            {{record.dis == 1 ?'送货上门' : (record.dis == 2 ? '自取' : '')}}
          </span>
          <span slot="action" slot-scope="record">
            <!--
            <a-button :disabled="!record.address_id" type="link" @click="getSendAdd(record)" size="small">送货地址</a-button>-->
            <a-button :disabled="record.status!=2" type="link" @click="sendFn(record)"  size="small">已提货</a-button>
            <a-button :disabled="record.status!=2" type="link" @click="deleteFn(record)"  size="small">取消</a-button>
          </span>
        </a-table>
        <a-table v-show="!isOrderTable" :columns="columnsSale" :data-source="saleData" :loading="loading"
          :rowKey="saleData => saleData.goods_id" :pagination="false">
        </a-table>
      </div>
    </div>
  </div>
</template>

<script>
//引入接口api
import {
  goodsOrderDatagrid,
  postDatalist,
  officeDatalist,
  goodsOrderDeliver,
  goodsOrderCancel,
  goodsOrderAddress,
  goodsOrderExcelExport,
  goodsSalesStatistic,

} from "@/request/api";
//引入工具函数
import util from "@/utils/util";
//引入封装的组件
import SearchBar from "@/components/common/SearchBar.vue";
import MyBreadcrumb from "@/components/common/MyBreadcrumb.vue";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    SearchBar,
    MyBreadcrumb,
  },
  data () {
    return {
      //传给MyBreadcrumb的参数
      breadcrumbs: [
        {
          key: 0,
          title: "用餐管理",
        },
        {
          key: 1,
          title: "小卖部订单管理",
        },
      ],

      //传给searchBar公共搜索组件的数据
      timeRange: {
        show: true,
        placeholderStart: "下单时间",
        placeholderEnd: "下单时间",
      },
      inputs: [
        {
          placeholder: "姓名",
          model: "realname",
          width: 100,
        },
        {
          placeholder: "手机",
          model: "mobile",
          width: 120,
        },
      ],
      selects: [
        {
          model: "office_id",
          placeholder: "部门",
          width: 200,
          options: [
            {
              key: "",
              value: "部门",
            },
          ],
        },
        {
          model: "post_id",
          placeholder: "职务",
          width: 100,
          options: [
            {
              key: "",
              value: "职务",
            },
          ],
        },
        {
          model: "status",
          placeholder: "订单状态",
          width: 100,
          options: [
            {
              key: "",
              value: "订单状态",
            },
            {
              key: 1,
              value: "未支付",
            },
            {
              key: 2,
              value: "待配送",
            },
            {
              key: 3,
              value: "已配送",
            },
            {
              key: 4,
              value: "已取消",
            },
          ],
        },
      ],


      //请求参数
      queryParam: {
        page: 1,
        begin_date: "",
        end_date: "",
        post_id: "",
        status: "",
        mobile: "",
        realname: "",
      },
      tableData: [], //从接口请求回来并在js部分整理好的表格数据
      dataForExport: [], //不分页的数据
      loading: false, //table加载状态

      // 表格的列配置
      columns: [
        {
          title: "订单号",
          key: "order_number",
          dataIndex: "order_number",
        },
        {
          title: "姓名",
          key: "realname",
          dataIndex: "sub_user.name",
          width: 80,
        },
        {
          title: "部门",
          key: "office",
          dataIndex: "sub_user.office.title",
          width: 80,
        },
        {
          title: "金额",
          key: "money",
          dataIndex: "money",
          width: 80,
        },
        {
          title: "手机",
          key: "mobile",
          dataIndex: "sub_user.mobile",
          width: 130,
        },
        {
          title: "订单状态",
          key: "status",
          dataIndex: "status_text",
          width: 100,
        },
        {
          title: "下单时间",
          key: "created_at",
          dataIndex: "created_at",
          width: 180,
        },
        {
          title: "配送方式",
          key: "dis",
          scopedSlots: { customRender: "dis" },
          width: 100,
        },
        {
          title: "订单详情",
          key: "get_order_info",
          dataIndex: "orderDetails",
          width: 180,
        },
        {
          title: "操作",
          key: "action",
          scopedSlots: { customRender: "action" },
          width: 150,
          fixed: 'right'
        },
      ],

      //页配置
      pagination: {
        total: 0,
        pageSize: 10,
        current: 1,
      },


      // 销量统计报表参数
      isOrderTable: true,
      columnsSale: [
        {
          title: "商品名称",
          key: "goods.title",
          dataIndex: "goods.title",
        },
        {
          title: "商品类型",
          key: "goods.goods_type.title",
          dataIndex: "goods.goods_type.title",
        },
        {
          title: "商品总收益",
          key: "money",
          dataIndex: "money",
        },
        {
          title: "商品总销量",
          key: "sales",
          dataIndex: "sales",
        }
      ],
      saleData: [],
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    //刷新和搜索一样的方法
    search (val) {
      this.queryParam = {
        page: 1,
        begin_date: val.timeRange.startTime,
        end_date: val.timeRange.endTime,
        mobile: val.input.mobile ? val.input.mobile : "",
        realname: val.input.realname ? val.input.realname : "",
        created_end: val.input.created_end ? val.input.created_end : "",
        status: val.select.status === '' ? "" : val.select.status,
        office_id: val.select.office_id ? val.select.office_id : "",
        post_id: val.select.post_id ? val.select.post_id : "",
      };
      this.pagination.current = 1;
      this.getTableData();
      this.getSaleData();
    },

    //获取表格数据
    getTableData () {
      this.loading = true;
      this.queryParam.no_paging = 0;
      goodsOrderDatagrid(this.queryParam).then((res) => {
        let resultData = res.data.result;
        //处理页码
        const pagination = { ...this.pagination };
        pagination.total = resultData.total;
        this.pagination = pagination;
        let items = resultData.items;
        items.forEach((item) => {
          // 判断info信息是否数组
          if (item.items instanceof Array) {
            let arr = [];
            item.items.forEach((element) => {
              let str = "";
              str = `${element.title}*${element.num}份`;
              arr.push(str);
            });
            if (arr.length > 1) {
              arr.join(",");
            }
            item.orderDetails = arr.toString();
          }
        });
        this.tableData = items;
      }).finally(()=>{
        this.loading = false;
      });

    },

    //分页
    handleTableChange (pagination) {
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      this.queryParam.page = pagination.current;
      this.getTableData();
    },

    //导出
    downloadExcel () {
      this.$confirm({
        title: "确定导出表格?",
        okText: "确定",
        cancelText: "取消",
        onOk: () => {
          if(this.isOrderTable){
              //订单数据导出
              this.export2Excel();
          } else {
              this.saleExport2Excel();
          }
          
        },
        onCancel: () => { },
      });
    },

    //订单数据写入excel
    export2Excel () {
      goodsOrderExcelExport(this.queryParam).then((res) => {
        util.acceptFileStream(res.data, "小卖部订单数据.xls");
      });
      /*
      var that = this;
      require.ensure([], () => {
        const { export_json_to_excel } = require("@/excel/export2Excel"); //这里必须使用绝对路径，使用@/+存放export2Excel的路径
        const tHeader = ["订单号", "姓名", "部门", "职务", "金额", "手机", "订单状态", "下单时间", "配送方式", "订单明细", "核销时间","送货地址"]; // 导出的表头名信息
        const filterVal = ["order_number", "realname", "office", "post", "money", "mobile", "status", "created_at", "dis", "get_order_info", "updated_at", "address"]; // 导出的表头字段名，需要导出表格字段名
        const list = that.dataForExport;
        const data = that.formatJson(filterVal, list);

        export_json_to_excel(tHeader, data, "小卖部订单数据"); // 导出的表格名称，根据需要自己命名
      });*/
    },
    //销量数据写入excel
    saleExport2Excel () {
      var that = this;
      let salesData = [];
      that.saleData.forEach(it=>{
        salesData.push({
          goods_title: it.goods.title,
          goods_type: it.goods.goods_type.title,
          sum_total: it.money,
          sum_num: it.sales
        });
      })
      require.ensure([], () => {
        const { export_json_to_excel } = require("@/excel/export2Excel"); //这里必须使用绝对路径，使用@/+存放export2Excel的路径
        const tHeader = ["商品名称", "商品类型", "商品总收益", "商品总销量"]; // 导出的表头名信息
        const filterVal = ["goods_title", "goods_type", "sum_total", "sum_num"]; // 导出的表头字段名，需要导出表格字段名
        const list = salesData
        const data = that.formatJson(filterVal, list);

        export_json_to_excel(tHeader, data, "小卖部销售数据"); // 导出的表格名称，根据需要自己命名
      });
    },

    //格式转换
    formatJson (filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },

    //获取部门列表
    getOffices () {
      officeDatalist({}).then((res) => {
        let items = res.data.result;
        for (let i = 0; i < items.length; i++) {
          this.selects[0].options.push({
            key: items[i].id,
            value: items[i].title,
          });
        }
      });
    },

    //获取职务列表
    getPosts () {
      postDatalist({ }).then((res) => {
        let items = res.data.result;
        for (let i = 0; i < items.length; i++) {
          this.selects[1].options.push({
            key: items[i].id,
            value: items[i].title,
          });
        }
      });
    },

    getSaleData () {
      goodsSalesStatistic(this.queryParam).then(res => {
        this.saleData = res.data.result
      })
    },

    changeTable () {

      if (this.isOrderTable) {
        this.isOrderTable = false

        this.selects.pop()
      } else {
        this.isOrderTable = true
        this.selects.push({
          model: "status",
          placeholder: "订单状态",
          width: 100,
          options: [
            {
              key: "",
              value: "订单状态",
            },
            {
              key: 0,
              value: "未支付",
            },
            {
              key: 1,
              value: "待配送",
            },
            {
              key: 2,
              value: "已配送",
            },
            {
              key: 3,
              value: "已取消",
            },
          ],
        })
      }
    },

    getSendAdd (record) {
      goodsOrderAddress({id:record.id}).then((res)=>{
        if(res.data.result){
          let {name, mobile, address} = res.data.result;
          this.$info({
            content: `姓名：${name}，联系方式：${mobile}，地址：${address}`
          })
        }else{
          this.$message.error('未找到相关信息')
        }
      })
    },
    deleteFn (record) {
      let id = record.id, orderNumber = record.order_number;
      this.$confirm({
        content: `是否取消订单${orderNumber}?`,
        onOk: () => {
          goodsOrderCancel({id}).then(res => {
            if(res.data.result>0){
              this.$message.success('取消成功')
              this.getTableData();
            }else{
              this.$message.error('操作失败')
            }
          });
        },
      })
    },
    sendFn (record) {
      let id = record.id, orderNumber = record.order_number;
      this.$confirm({
        content: `是否配送订单${orderNumber}?`,
        onOk: () => {
          goodsOrderDeliver({id}).then(res => {
            if(res.data.result>0){
              this.$message.success('配送成功')
              this.getTableData();
            }else{
              this.$message.error('操作失败')
            }
          });
        },
      })
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created () {
    this.getTableData();
    this.getSaleData();
    this.getOffices();
    this.getPosts();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted () { },
  beforeCreate () { }, //生命周期 - 创建之前
  beforeMount () { }, //生命周期 - 挂载之前
  beforeUpdate () { }, //生命周期 - 更新之前
  updated () { }, //生命周期 - 更新之后
  beforeDestroy () { }, //生命周期 - 销毁之前
  destroyed () { }, //生命周期 - 销毁完成
  activated () { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.mainBox {
  background-color: #f0f2f5;
  .control_box {
    background-color: white;
    padding: 20px;
    .control_box_bottom {
      margin-top: 20px;
    }
  }
  .show_box {
    width: 100%;
    padding-top: 10px;
  }
}
</style>